import Badge from '@mui/material/Badge';

const Active = () => (
  <Badge
    variant="dot"
    sx={(theme) => ({
      height: '.5rem',
      width: '.5rem',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      // Inside the header card, just under the icon, as the client's home
      // page picture draws it (2026-10). Placed against the toolbar: no
      // element between is positioned.
      bottom: '4px',
    })}
  />
);

export default Active;
